import React from 'react';
import {AdminPayoutsVO} from "../../../types/model/valueObject/payout/AdminPayoutsVO";
import {AdminPayoutsCardListItem} from "./AdminPayoutsCardListItem";
import {withLoader} from "../../hocs/withLoader";
import {LocationCardSkeleton} from "../../common/reports/loadingSkeletons/LocationCardSkeleton";

type AdminPayoutsCardListProps = {
  items?: AdminPayoutsVO[];
  expandByIndex: Array<boolean>;
  onToggleExpand: (index: number) => void;
}

const AdminPayoutsCardList = ({
  items,
  expandByIndex,
  onToggleExpand
}: AdminPayoutsCardListProps) => {
  if (!items?.length) {
    return null;
  }

  return <>
    {
      items.map((item, index) =>
        <AdminPayoutsCardListItem
          key={index}
          item={item}
          expanded={expandByIndex[index]}
          onToggleExpand={() => onToggleExpand(index)}
        />
      )
    }
  </>
}

const skeletonLoader = () => Array.from({ length: 10 }).map((_, index) => (
  <LocationCardSkeleton key={index} />
));

const AdminPayoutsCardListWithLoader = withLoader(AdminPayoutsCardList, skeletonLoader);

export {
  AdminPayoutsCardList,
  AdminPayoutsCardListWithLoader
};
